import { jsx as _jsx } from "react/jsx-runtime";
import { Button as BaseButton } from '@base-ui/react/button';
import React from 'react';
import { iconButtonStyles } from './icon-button-styles';
/**
 * An icon-only action. Renders a `<button>` (via base-ui `Button`, which enforces button
 * semantics) by default — `aria-label` is required since there is no visible text to derive an
 * accessible name from. Pass `decorative` to render a non-interactive, `aria-hidden` `<span>`
 * instead (e.g. when nested inside an ancestor that's already the click target, like `Tile`'s or
 * `Card`'s whole-item link) — no `aria-label` needed in that mode. For navigation, use
 * `IconButtonLink`.
 */
export const IconButton = React.forwardRef((props, ref) => {
    const { icon, variant = 'darkGrey', shape = 'square', className } = props;
    if (props.decorative) {
        return (_jsx("span", { "aria-hidden": true, className: iconButtonStyles({ variant, shape, className }), children: icon }));
    }
    const { icon: _icon, variant: _variant, shape: _shape, className: _className, decorative: _decorative, disabled, ...buttonProps } = props;
    return (_jsx(BaseButton, { ref: ref, className: iconButtonStyles({ variant, shape, className }), disabled: disabled, "aria-disabled": disabled || undefined, ...buttonProps, children: icon }));
});
IconButton.displayName = 'IconButton';
